import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import tr from "./locales/tr/translation.json";

// i18next yapılandırması
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    lng: "en",          
    fallbackLng: "tr",      
    interpolation: {
      escapeValue: false,  
    },
    debug: false,         
  });

export default i18n;